export const projects = [
  {
    id: "distributed-cache",
    name: "Distributed Cache System",
    description: "A high-performance distributed caching system built with Redis and Go, supporting consistent hashing and automatic failover.",
    techStack: ["Go", "Redis", "Docker", "Kubernetes"],
    github: "https://github.com/yalathiy/distributed-cache",
    liveUrl: null,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop",
    featured: true
  },
  {
    id: "realtime-analytics",
    name: "Real-time Analytics Pipeline",
    description: "Stream processing pipeline for real-time analytics using Apache Kafka, processing millions of events per second with low latency.",
    techStack: ["Kafka", "Python", "ClickHouse", "Grafana"],
    github: "https://github.com/yalathiy/realtime-analytics",
    liveUrl: null,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    featured: true
  },
  {
    id: "database-profiler",
    name: "Database Query Profiler",
    description: "A tool for profiling and analyzing database query performance with detailed execution plans and recommendations.",
    techStack: ["Node.js", "PostgreSQL", "React", "D3.js"],
    github: "https://github.com/yalathiy/db-profiler",
    liveUrl: "https://db-profiler-demo.com",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
    featured: true
  },
  {
    id: "api-gateway",
    name: "Lightweight API Gateway",
    description: "A fast, lightweight API gateway with rate limiting, authentication, and request routing capabilities.",
    techStack: ["Rust", "Redis", "PostgreSQL", "Docker"],
    github: "https://github.com/yalathiy/api-gateway",
    liveUrl: null,
    image: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=800&h=600&fit=crop",
    featured: false
  }
];
